// Classify a booking URL by its third-party vendor, for the `booking_vendor`
// analytics dimension. Booking happens off-site (booksalon.dk / Timma); GA4
// can't see which system the visitor lands in, so we tag the hand-off.

export type BookingVendor = 'booksalon' | 'timma' | 'other'

export function bookingVendor(url: string): BookingVendor {
  if (url.includes('booksalon.dk')) return 'booksalon'
  if (url.includes('timma.dk')) return 'timma'
  return 'other'
}
